import { Route, Routes } from 'react-router-dom';
import { Suspense } from 'react';
import { Spin } from 'antd';
import { allRoutes, AppRoute } from './routes/routeConfig';

const renderRoutes = (routes: AppRoute[]) =>
  routes.map((route, idx) => {
    const { path, index, element, children } = route;
    const key = path ?? `index-${idx}`;
    const routeProps: any = { element };
    
    if (path) routeProps.path = path;
    if (index) routeProps.index = true;

    return (
      <Route key={key} {...routeProps}>
        {children && renderRoutes(children)}
      </Route>
    );
  });

const App = () => (
  <Suspense fallback={
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <Spin size="large" tip="Đang tải...">
         <div /> 
      </Spin>
    </div>
  }>
    <Routes>{renderRoutes(allRoutes)}</Routes>
  </Suspense>
);

export default App;
